import React from 'react';
import './Gallery.css';
import GalleryImage from '../../../assets/Gallery/galleryOne.png'
import GalleryImage2 from '../../../assets/Gallery/galleryTwo.png'
import GalleryImage3 from '../../../assets/Gallery/galleryThree.png'
import GalleryImage4 from '../../../assets/Gallery/galleryFour.png'
import GalleryImage5 from '../../../assets/Gallery/aboutOne.png'
import GalleryImage6 from '../../../assets/Gallery/aboutTwo.png'
import GalleryImage7 from '../../../assets/Gallery/roadmapThree.png'
import GalleryImage8 from '../../../assets/Gallery/roadmapTwo.png'

function Gallery() {
    
    return (
        <div className='gallery-outer d-flex justify-content-center align-items-center w-100'>
            <div className="gallery-inner d-flex justify-content-center align-items-center flex-column w-100">
                <h2 className="header-text w-100 text-align-left">Our Pride</h2>
                <div className="gallery-frame d-flex justify-content-center align-items-center">
                    <div className="gallery-box">
                        <img src={GalleryImage} alt="" />
                    </div>
                    <div className="gallery-box">
                        <img src={GalleryImage2} alt="" />
                    </div>
                    <div className="gallery-box">
                        <img src={GalleryImage3} alt="" />
                    </div>
                    <div className="gallery-box">
                        <img src={GalleryImage4} alt="" />
                    </div>
                    <div className="gallery-box">
                        <img src={GalleryImage5} alt="" />
                    </div>
                    <div className="gallery-box">
                        <img src={GalleryImage6} alt="" />
                    </div>
                    <div className="gallery-box">
                        <img src={GalleryImage7} alt="" />
                    </div>
                    <div className="gallery-box">
                        <img src={GalleryImage8} alt="" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Gallery
